import styled from '@emotion/styled';
import { themeV1 } from '../theme';

export const BaseText = styled('span')({
  fontFamily: themeV1.font.fontFamily.montserrat,
  color: themeV1.colors.base.white,
});
